import MasonryGrid from '../components/MasonryGrid';
import ProductListItem from '../components/ProductListItem';
import Select from '../components/Select';
import FacetedFilters from '../components/FacetedFilters';

export default class StaticCollection {
  constructor(section) {
    this.el = section.el;
    this.collectionSortingEl = this.el.querySelector('[data-collection-sorting]');
    this.masonry = this.el.querySelector('[data-masonry-grid]');
    this.masonryGrid = null;

    this.productListItems = [];
    this.el
      .querySelectorAll('.product-list-item')
      .forEach(product => this.productListItems.push(new ProductListItem({ el: product })));

    if (this.collectionSortingEl) {
      this.collectionSortingEl.addEventListener('change', event => this.sortCollection(event));
      new Select({ el: this.collectionSortingEl });
    }

    if (this.masonry) {
      this.masonryGrid = new MasonryGrid({
        el: this.masonry,
        settings: {
          itemSelector: '.product-list-item',
          horizontalOrder: true,
        },
      });
    }

    this.facetedFilters = new FacetedFilters(section);
  }

  remove() {
    if (this.masonryGrid) {
      this.masonryGrid.unload();
    }

    this.productListItems.forEach(item => item.remove());

    if (this.collectionSortingEl) {
      this.collectionSortingEl.removeEventListener('change', event => this.sortCollection(event));
    }
  }

  sortCollection(event) {
    const { currentTarget } = event;
    let search;

    const Sorting = {};
    Sorting.sort_by = currentTarget.value;

    const currentVendorSelected = currentTarget.closest('.select-wrapper').classList.contains('vendor-collection');
    const facetedFiltersEnabled = document.querySelector('[data-faceted-filter]');

    if (currentVendorSelected || facetedFiltersEnabled) {
      const currentSearch = location.search;
      const searchParts = currentSearch.split('&');

      for (let index = 0; index < searchParts.length; index++) {
        const part = searchParts[index];
        if (part.indexOf('sort_by') !== -1) {
          searchParts.splice(index, 1);
        }
      }

      search = searchParts.join('&');
      location.search = `${search}&${Object.keys(Sorting).map(k => (
        `${encodeURIComponent(k)}=${encodeURIComponent(Sorting[k])}`
      )).join('&')}`;
    } else {
      location.search = Object.keys(Sorting).map(k => (
        `${encodeURIComponent(k)}=${encodeURIComponent(Sorting[k])}`
      )).join('&');
    }
  }

  onSectionUnload() {
    this.remove();
    this.facetedFilters.unload();
  }
}
